// hooks/useNotifications.js
import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

export const useNotifications = (userId) => {
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!userId) return;

    // Charger le compteur initial
    const fetchUnreadCount = async () => {
      try {
        const { count, error } = await supabase
          .from('notifications')
          .select('*', { count: 'exact', head: true })
          .eq('user_id', userId)
          .eq('is_read', false);

        if (error) throw error;
        setUnreadCount(count || 0);
      } catch (error) {
        console.error('Erreur comptage notifications:', error);
      }
    };

    fetchUnreadCount();

    // S'abonner aux changements en temps réel
    const channel = supabase
      .channel('unread_notifications')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'notifications',
          filter: `user_id=eq.${userId}`
        },
        (payload) => {
          if (payload.eventType === 'INSERT' && !payload.new.is_read) {
            setUnreadCount(prev => prev + 1);
          } else if (payload.eventType === 'UPDATE') {
            if (payload.new.is_read && !payload.old.is_read) {
              setUnreadCount(prev => Math.max(0, prev - 1));
            } else if (!payload.new.is_read && payload.old.is_read) {
              setUnreadCount(prev => prev + 1);
            }
          } else if (payload.eventType === 'DELETE' && !payload.old.is_read) {
            setUnreadCount(prev => Math.max(0, prev - 1));
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [userId]);

  return unreadCount;
};